import React, { PureComponent, ReactNode } from "react";
import styled from "styled-components";

import freeShipping from "../../../../../../../assets/images/freeShipping.png";
import greatestChoice from "../../../../../../../assets/images/greatestChoice.png";
import merchantPartner from "../../../../../../../assets/images/merchantPartner.svg";
import securePackaging from "../../../../../../../assets/images/securePackaging.png";
import { translate } from "../../../../../../../services/translation.service";
import { media } from "../../../../../../../theme";
import SectionFooter from "../SectionFooter";

import ReinsuranceBlock from "./components/ReinsuranceBlock";

const ReinsuranceBlocksWrapper = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;

  ${media.laptop} {
    flex-wrap: initial;
  }
`;

export default class ReinsuranceSection extends PureComponent<{}> {
  public render(): ReactNode {
    return (
      <SectionFooter>
        <ReinsuranceBlocksWrapper>
          <ReinsuranceBlock
            icon={{
              name: translate("footer.greatestChoice"),
              url: greatestChoice,
              width: 40,
            }}
            title={translate("footer.greatestChoice")}
            subtitles={[
              translate("footer.productsNumber"),
              translate("footer.brandsNumber"),
            ]}
          />
          <ReinsuranceBlock
            icon={{
              name: translate("footer.freeDelivery"),
              url: freeShipping,
              width: 40,
            }}
            title={translate("footer.freeDelivery")}
            subtitles={[translate("footer.fromAmountInFrance")]}
          />
          <ReinsuranceBlock
            icon={{
              name: translate("footer.safePackaging"),
              url: securePackaging,
              width: 40,
            }}
            title={translate("footer.safePackaging")}
            subtitles={[
              translate("footer.safeShippingCardboard"),
              translate("footer.policyConditions"),
            ]}
          />
          <ReinsuranceBlock
            icon={{
              name: translate("footer.customersSatisfaction"),
              url: merchantPartner,
              width: 40,
            }}
            title={translate("footer.customersSatisfaction")}
            subtitles={[translate("footer.customersOpinion")]}
          />
        </ReinsuranceBlocksWrapper>
      </SectionFooter>
    );
  }
}
